<template>
  <VTDropdownPill
    :disable-save-button="!isDailyLimitValid()"
    :is-enabled="!disabled"
    @confirm="saveChanges"
    @clear="reset"
    @on-click-outside="discardChanges"
  >
    <template #dropDownHeader>
      <VTPill label="Daily Display Limit">
        <template #values>
          <div :class="$style.wrapper">
            <div>
              <div :class="$style.row">
                <div :class="[$style.column, $style.timeText]">
                  {{ props.modelValue }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </VTPill>
    </template>
    <template #dropdown-content>
      <div :class="$style.dropdownContainer">
        <p>Maximum daily impressions for the offer</p>
        <InputNumber v-model="dailyLimit" mode="decimal" :max="999" :min="1" />
        <div v-if="!isDailyLimitValid()">
          <p :class="$style.invalidText">Daily display limit should be between 1 and 999.</p>
        </div>
      </div>
    </template>
  </VTDropdownPill>
</template>

<script setup lang="ts">
import type { Ref } from "vue";
import { ref } from "vue";
import VTDropdownPill from "@/components/VTDropdownPill";
import VTPill from "@/components/VTPill";
import InputNumber from "primevue/inputnumber";

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["update"]);
const dailyLimit: Ref<number> = ref(props.modelValue);
const saveChanges = () => {
  emit("update", dailyLimit.value);
};
const reset = () => {
  emit("update", 999);
  dailyLimit.value = 999;
};
const discardChanges = () => {
  dailyLimit.value = props.modelValue;
};
const isDailyLimitValid = () => dailyLimit.value <= 999 && dailyLimit.value >= 1;
</script>
<style module>
.wrapper {
  display: flex;
  flex-direction: row;
  overflow-x: hidden;
  align-items: center;
  gap: 8px;
}
.dropdownContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.row {
  display: flex;
  position: relative;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
}
.column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.timeText {
  font-weight: 700;
  font-size: 14px;
}
.invalidText {
  color: #f56b6b;
  margin: 0;
  padding: 0;
}
</style>
